module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    staticClass: "details-order"
  }, [(_vm.orderDataShow.attributes.type === 2) ? _c('div', {
    staticClass: "details-order-block details-image",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.orderDataShow.attributes.product_image_url === null) ? _c('img', {
    attrs: {
      "src": "/static/img/icon/caja.svg",
      "width": "180px",
      "height": "260px"
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.orderDataShow.attributes.product_image_url,
      "width": "180px",
      "height": "260px"
    }
  })]) : _c('div', {
    staticClass: "details-order-block details-image",
    staticStyle: {
      "text-align": "center"
    }
  }, [(
    _vm.orderDataShow.attributes.product_image_url == null &&
    _vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('img', {
    attrs: {
      "src": 'https://pngimage.net/wp-content/uploads/2018/06/producto-icono-png-3.png',
      "width": "180px",
      "height": "260px"
    }
  }) : (
    _vm.orderDataShow.attributes.product_image_url == null &&
    _vm.orderDataShow.attributes.is_from_linio_flag
  ) ? _c('img', {
    attrs: {
      "src": "/static/img/linio-logo.png",
      "width": "180px",
      "height": "260px"
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.orderDataShow.attributes.product_image_url,
      "width": "180px",
      "height": "260px"
    }
  }), _c('br'), _c('br'), _vm._v(" "), (_vm.orderDataShow.attributes.sku != null) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.linksku,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código SKU'),
      expression: "'Código SKU'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace color",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.sku))])]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.type === 2) ? _c('div', {
    staticClass: "details-order-block details-info"
  }, [_c('div', {
    staticClass: "details-title"
  }, [_c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "title-order mr-5"
  }, [_vm._v("\n              " + _vm._s(_vm.orderDataShow.attributes.product_info)), (_vm.orderDataShow.attributes.reference_link !== null) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.reference_link,
      "target": "_Blank"
    }
  }, [_vm._v("\n                - "), _c('img', {
    attrs: {
      "src": "/static/img/icon/icon-url.svg"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('b', {
    staticClass: "d-block ml-auto"
  }, [_vm._v(" #" + _vm._s(_vm.orderDataShow.id))])])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cantidad :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.product_specimens))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Precio Referencial :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.real_price))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Peso :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.weight_kg) + " Kg")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Categoría :")]), _vm._v(" "), (_vm.orderDataShow.attributes.mp_category_key !== null) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.category.attributes.key)), _c('br'), _vm._v("\n              " + _vm._s(_vm.orderDataShow.attributes.category.attributes.name)), _c('br'), _vm._v("\n              " + _vm._s(_vm.orderDataShow.attributes.category.attributes.margin) + "\n            ")]) : _c('span', {
    staticClass: "details-title-item"
  })]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Descripción :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.description === null ?
    "Sin descripción" :
    _vm.orderDataShow.attributes.description))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Variaciones :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.variations === null ?
    "Sin variaciones" :
    _vm.orderDataShow.attributes.variations))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Packing :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusIsPackage),
      expression: "statusIsPackage"
    }],
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusIsPackage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeStatusIsPackage]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    },
    domProps: {
      "selected": _vm.orderDataShow.attributes.isPackage === _vm.statusIsPackage
    }
  }, [_vm._v("\n                  SI\n                ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    },
    domProps: {
      "selected": _vm.orderDataShow.attributes.isPackage === _vm.statusIsPackage
    }
  }, [_vm._v("\n                  NO\n                ")])])])])])])]) : _c('div', {
    staticClass: "details-order-block details-info"
  }, [_c('div', {
    staticClass: "details-title"
  }, [_c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {}, [_c('span', {
    staticClass: "title-order"
  }, [_vm._v("\n              " + _vm._s(_vm.orderDataShow.attributes.product_info)), (_vm.orderDataShow.attributes.type === 2) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.reference_link,
      "target": "_Blank"
    }
  }, [_vm._v("\n                - "), _c('img', {
    attrs: {
      "src": "/static/img/icon/icon-url.svg",
      "alt": ""
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('div', {
    staticClass: "order-type"
  }, [_c('span', {
    staticClass: "code-order system-code"
  }, [_vm._v("\n                SB # " + _vm._s(_vm.orderDataShow.attributes.order_code))]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', [_c('span', {
    staticClass: "code-order-container"
  }, [_c('div', {
    staticClass: "circle-separador"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "circle-separador"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'https://grabr.io/es/grabs/' +
        _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_order_number,
      "target": "_blank"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Codigo del Partner'),
      expression: "'Codigo del Partner'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v("#" + _vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes
    .grabr_order_number) + "\n                    ")])])])]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', [_vm._m(1)]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', [_vm._m(2)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-container"
  }, [(!_vm.editDescriptionFlag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', [_vm._v(_vm._s(_vm.orderDataShow.attributes.description != null ?
    _vm.orderDataShow.attributes.description :
    "Sin descripción"))]), _vm._v(" "), (
    _vm.fromDetail &&
    _vm.orderDataShow.attributes.status != 10 &&
    _vm.orderDataShow.attributes.cancelled == 0
  ) ? _c('span', {
    staticClass: "details-title-item",
    on: {
      "click": _vm.editDescription
    }
  }, [_vm._v("Editar"), _c('i', {
    staticClass: "fas fa-edit"
  })]) : _vm._e()]) : _c('div', {
    staticClass: "details-title-block"
  }, [_c('div', {
    staticClass: "input-group input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('span', {
    staticClass: "details-title-item",
    attrs: {
      "disabled": _vm.description != _vm.descriptionRealValue
    },
    on: {
      "click": _vm.updateDescription
    }
  }, [_vm._v("Guardar cambios")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item",
    on: {
      "click": _vm.cancelEditDescription
    }
  }, [_c('i', {
    staticClass: "fas fa-times",
    staticStyle: {
      "cursor": "pointer"
    }
  })])])])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tienda: ")]), _vm._v(" "), (_vm.orderDataShow.attributes.meliOrder.attributes.store) ? _c('span', {
    staticClass: "tag-grabr"
  }, [(_vm.orderDataShow.attributes.meliOrder.attributes.store === 'electro') ? _c('span', {
    staticClass: "badge badge-dark badge-store bg-primary"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.store))]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.meliOrder.attributes.store === 'fashion') ? _c('span', {
    staticClass: "badge badge-dark badge-store brown"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.store))]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.meliOrder.attributes.store === 'kids') ? _c('span', {
    staticClass: "badge badge-dark badge-store magenta"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.store))]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.meliOrder.attributes.store === 'home') ? _c('span', {
    staticClass: "badge badge-dark badge-store bg-success"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.store))]) : _vm._e()]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("No definido")])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de orden:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.meliOrder.attributes.meli_order_link,
      "target": "_blank"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código del partner'),
      expression: "'Código del partner'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.meli_order_id))])])]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de orden:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.linioOrder.attributes.linio_order_link,
      "target": "_blank"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código del partner'),
      expression: "'Código del partner'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.linio_order_id))])])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de publicación:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.meliOrder.attributes.publication_code_link,
      "target": "_blank"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código de publicación'),
      expression: "'Código de publicación'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.publication_code))])])]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de publicación:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'http://www.linio.com.pe/' +
        _vm.orderDataShow.attributes.linioOrder.attributes.linio_publication_code +
        '.html',
      "target": "_blank"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('ID de la orden'),
      expression: "'ID de la orden'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.linio_publication_code))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-container"
  }, [(!_vm.editPackagedFlag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Empaque")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.packaged == null ?
    "Sin especificar" :
    _vm.orderDataShow.attributes.packaged == 1 ?
    "Sí" :
    "No"))]), _vm._v(" "), (
    _vm.fromDetail &&
    _vm.orderDataShow.attributes.status != 10 &&
    _vm.orderDataShow.attributes.cancelled == 0 &&
    !_vm.orderDataShow.attributes.is_from_linio_flag
  ) ? _c('span', {
    staticClass: "details-title-item",
    on: {
      "click": _vm.editPackaged
    }
  }, [_vm._v("Editar"), _c('i', {
    staticClass: "fas fa-edit"
  })]) : _vm._e()])]) : _c('div', {
    staticClass: "details-title-block"
  }, [_c('div', {
    staticClass: "input-group input-box"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packaged),
      expression: "packaged"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "name": "packaged"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.packaged = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Sin especificar")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Sí")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('span', {
    staticClass: "details-title-item",
    attrs: {
      "disabled": _vm.packaged != _vm.packagedRealValue
    },
    on: {
      "click": _vm.updatePackaged
    }
  }, [_vm._v("Guardar cambios")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item",
    on: {
      "click": _vm.cancelEditPackaged
    }
  }, [_c('i', {
    staticClass: "fas fa-times",
    staticStyle: {
      "cursor": "pointer"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cantidad entregada")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.product_specimens_delivered))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cantidad total")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.product_specimens))])]), _vm._v(" "), (!_vm.editCostingMethodFlag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Met. costeo:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.costing_method == 1 ?
    "PESO (7usd/kg)" :
    _vm.orderDataShow.attributes.costing_method == 2 ?
    "TRAVELER" :
    _vm.orderDataShow.attributes.costing_method == 3 ?
    "ALTERNATIVO" :
    "No definido"))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.weight_kg != null ?
    _vm.orderDataShow.attributes.weight_kg + " kg" :
    "No definido"))]), _vm._v(" "), (_vm.orderDataShow.attributes.status == 2) ? _c('span', {
    staticClass: "details-title-item",
    on: {
      "click": _vm.editCostingMethod
    }
  }, [_vm._v("Editar"), _c('i', {
    staticClass: "fas fa-edit"
  })]) : _vm._e()])]) : _c('div', {
    staticClass: "details-title-block"
  }, [_c('div', {
    staticClass: "input-group input-box"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.costingMethod),
      expression: "costingMethod"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "name": "costingMethod"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.costingMethod = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeCostingMethod]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Peso (7usd/kg)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Traveler")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Alternativo")])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('span', {
    staticClass: "details-title-item",
    attrs: {
      "disabled": _vm.costingMethod != _vm.costingMethodRealValue
    },
    on: {
      "click": _vm.updateCostingMethod
    }
  }, [_vm._v("Guardar cambios")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item",
    on: {
      "click": _vm.cancelEditCostingMethod
    }
  }, [_c('i', {
    staticClass: "fas fa-times",
    staticStyle: {
      "cursor": "pointer"
    }
  })])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tag-grabr"
  }, [_c('span', {
    staticClass: "badge badge-primary badge-grabr"
  }, [_vm._v("Grabr")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "code-order-container"
  }, [_c('div', {
    staticClass: "circle-separador"
  }), _vm._v(" "), _c('span', {
    staticClass: "tag-grabr"
  }, [_c('span', {
    staticClass: "badge badge-primary badge-linio"
  }, [_vm._v("Linio")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "code-order-container"
  }, [_c('div', {
    staticClass: "circle-separador"
  }), _vm._v(" "), _c('span', {
    staticClass: "tag-grabr"
  }, [_c('span', {
    staticClass: "badge badge-primary badge-meli"
  }, [_vm._v("Mercado Libre")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d727b778"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prefab/elements/order-important-info.vue
// module id = 1917
// module chunks = 1